// Voz del navegador para leer en voz alta el contenido en ingles de las lecciones.
// (En el futuro se puede reemplazar por audios reales grabados, igual que EspanolGo.)

// Nombres de voces del sistema que suenan masculinas o femeninas. Los
// navegadores no dicen el genero de cada voz, asi que lo deducimos por el
// nombre (Windows: David/Mark/Guy vs Zira/Aria/Jenny; Mac: Alex/Daniel vs
// Samantha/Karen; Google: "Male"/"Female").
const VOZ_MASCULINA = /(david|mark|guy|christopher|eric|roger|ryan|brian|george|james|daniel|alex|fred|tom|aaron|arthur|\bmale\b)/i
const VOZ_FEMENINA  = /(zira|aria|jenny|michelle|emma|samantha|karen|susan|hazel|libby|sonia|victoria|allison|ava|joanna|kendra|kimberly|salli|nicole|serena|\bfemale\b)/i

function vocesIngles(voces) {
  return voces.filter(v => v.lang && v.lang.toLowerCase().startsWith('en'))
}

function elegirVoz(voces, genero) {
  const ingles = vocesIngles(voces)
  const enUS = ingles.filter(v => v.lang === 'en-US')
  if (genero === 'm' || genero === 'f') {
    const patron = genero === 'm' ? VOZ_MASCULINA : VOZ_FEMENINA
    const exacta = enUS.find(v => patron.test(v.name)) || ingles.find(v => patron.test(v.name))
    if (exacta) return { voz: exacta, genero: true }
  }
  // Sin voz del genero pedido: voz en ingles por defecto (y se ajusta el tono)
  return { voz: enUS[0] || ingles[0], genero: false }
}

// onFin (opcional): se llama cuando la lectura termina (o falla), para que
// quien pidio hablar() sepa el momento exacto en que puede continuar (por
// ejemplo, la escena animada que avanza de una linea de dialogo a la
// siguiente solo cuando el navegador de verdad termino de decir la linea
// actual, en vez de adivinar un tiempo fijo).
//
// opciones.genero (opcional): 'm' o 'f'. Usa una voz masculina o femenina si
// el dispositivo tiene una; si no, cambia el tono de la voz disponible para
// que se note la diferencia.
export function hablar(texto, onFin, opciones) {
  if (!window.speechSynthesis || !texto) { if (onFin) onFin(); return }
  window.speechSynthesis.cancel()
  const generoPedido = opciones && opciones.genero

  // Chrome tiene un bug conocido: si un texto tarda mas de ~15 segundos
  // en leerse, el motor de voz se "pausa" solo y corta la lectura a la
  // mitad. El truco para evitarlo es llamar resume() cada tanto mientras
  // dura la lectura. El intervalo se apaga solo cuando la lectura realmente
  // termina (o falla), con un limite de seguridad de 2 minutos por si el
  // evento no llega.
  const intervalId = setInterval(() => window.speechSynthesis.resume(), 200)
  const idSeguridad = setTimeout(() => clearInterval(intervalId), 120000)
  let yaTermino = false
  function detenerIntervalo() {
    clearInterval(intervalId)
    clearTimeout(idSeguridad)
    if (!yaTermino) { yaTermino = true; if (onFin) onFin() }
  }

  const u = new SpeechSynthesisUtterance(texto)
  u.lang = 'en-US'; u.rate = 0.9; u.pitch = 1.0
  u.onend = detenerIntervalo
  u.onerror = detenerIntervalo

  function configurarYHablar() {
    window.speechSynthesis.onvoiceschanged = null // evita que hable dos veces
    const { voz, genero: encontroGenero } = elegirVoz(window.speechSynthesis.getVoices(), generoPedido)
    if (voz) u.voice = voz
    // Si no hay una voz del genero pedido, se simula con el tono
    if (!encontroGenero) {
      if (generoPedido === 'm') u.pitch = 0.7
      else if (generoPedido === 'f') u.pitch = 1.2
    }
    window.speechSynthesis.speak(u)
  }

  if (window.speechSynthesis.getVoices().length > 0) {
    configurarYHablar()
  } else {
    window.speechSynthesis.onvoiceschanged = configurarYHablar
  }
}

// Se mantiene para compatibilidad con PaginaLeccion.jsx (no hay mapa de audios reales aun)
export function precargarMapaAudios() {
  return Promise.resolve()
}
